import queryString from 'query-string';
import resolutions from '../resolutions/resolutions';

window.isUnderTeams = queryString.parse(location.search).source === 'teams';
const isUnderTeams = () => window.isUnderTeams || queryString.parse(location.search).source === 'teams';
const isUnderTeamsMobile = () => isUnderTeams() && resolutions.isLowResolution();
const isUnderTeamsDesktop = () => isUnderTeams() && !resolutions.isLowResolution();

export default {
  isUnderTeams,
  isUnderTeamsMobile,
  isUnderTeamsDesktop,
};
